<template>
	<div>
		<ui-toolbar
			class="ui-toolbar ui-elevation-1"
			dense
		>
			<span
				v-if="user.recorder"
				:title="`You may call ${user.recorder.uri} from your video system or platform to start a recording or streaming session`"
				class="ui-toolbar__recorder"
			>
				Your address: <strong>{{ user.recorder.uri }}</strong>
			</span>
			<div class="ui-toolbar-section-end">
				<ui-menu
					icon="fa fa-bars"
					size="medium"
				>
					<ui-menu-item
						v-if="isAdmin"
						icon="fal fa-user-shield"
						label="Admin"
						@click="openTab('/adm')"
					/>
					<ui-menu-item
						icon="fal fa-newspaper"
						label="News"
						@click="openTab('/news')"
					/>
					<ui-menu-item
						icon="fal fa-question-circle"
						label="Help"
						@click="openTab('/help')"
					/>
					<ui-menu-item
						icon="fal fa-envelope"
						label="Support"
						@click="$refs.feedbackDialog.open()"
					/>
					<ui-menu-item
						icon="fal fa-user-cog"
						label="Profile"
						@click="$refs.profileDialog.open()"
					/>
					<ui-menu-item
						icon="fal fa-database"
						label="Storage"
						@click="$refs.storageDialog.open()"
					/>
					<ui-menu-item
						icon="fal fa-cog"
						label="Settings"
						@click="$refs.settingsDialog.open()"
					/>
					<ui-menu-item
						icon="fal fa-sign-out-alt"
						label="Logout"
						@click="logout"
					/>
				</ui-menu>
			</div>
		</ui-toolbar>

		<feedback-dialog ref="feedbackDialog" />

		<profile-dialog ref="profileDialog" :user="user" />
		<storage-dialog ref="storageDialog" :recorder="user.recorder" />
		<settings-dialog ref="settingsDialog" :recorder="user.recorder" />
	</div>
</template>

<script>
import FeedbackDialog from "components/FeedbackDialog";
import ProfileDialog from "components/ProfileDialog";
import SettingsDialog from "components/SettingsDialog";
import StorageDialog from "components/StorageDialog";
import UiMenu from "lib/components/ui/Menu";
import UiMenuItem from "lib/components/ui/MenuItem";
import UiToolbar from "lib/components/ui/Toolbar";

import auth from "lib/modules/Auth";

export default {
	name: "Navigation",
	components: {
		FeedbackDialog,
		ProfileDialog,
		SettingsDialog,
		StorageDialog,
		UiMenu,
		UiMenuItem,
		UiToolbar
	},
	props: {
		user: {
			type: Object,
			required: true
		}
	},
	computed: {
		isAdmin() {
			if (this.user.roles.includes("ROLE_SUPER_ADMIN") ||
			    this.user.roles.includes("ROLE_ADMIN") ||
			    this.user.roles.includes("ROLE_READ_ADMIN")
			)
				return true;

			return false;
		}
	},
	methods: {
		logout() {
			auth.logout();
		},
		openTab(url) {
			window.open(url, "_blank");
		}
	}
};
</script>

<style lang="scss" scoped>
.ui-toolbar {
	flex-wrap: nowrap;
	.ui-toolbar__recorder {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}
</style>
